import React, { useMemo } from 'react'
import { parse, stringify } from '@adobe/css-tools'
import { useSearchParams } from 'react-router-dom'


const ReportRenderer = ({ pageCss, pageHTML, pageId }) => {

    const [searchParams] = useSearchParams()
    const isPDF = searchParams.get('ispdf');

    const parsePageCss = (cssString, pageClass) => {
        const parsedCss = parse(cssString)
        parsedCss.stylesheet.rules.forEach(rule => {
            if (rule.selectors) {
                rule.selectors = rule.selectors.map(selector => `.${pageClass} ${selector}`)
            }

            if (rule.media) {
                rule.rules.forEach(mediaRule => {
                    if (mediaRule.selectors) {
                        mediaRule.selectors = mediaRule.selectors.map(selector => `.${pageClass} ${selector}`);
                    }
                });
            }

            if (rule.type === 'font-face') {
                const newFontFaceRule = { ...rule };
                newFontFaceRule.declarations = newFontFaceRule.declarations.map(declaration => ({ ...declaration, property: `.${pageClass} ${declaration.property}`, }));
                parsedCss.stylesheet.rules.push(newFontFaceRule);
            }
        })

        return stringify(parsedCss)
    }

    const scopedCss = useMemo(() => {
        if (pageId && pageCss) {
            return parsePageCss(pageCss, `report_page_${pageId}`)
        }
        return ''
    }, [pageCss, pageId])

    return (
        <>
            {scopedCss && <style dangerouslySetInnerHTML={{ __html: scopedCss }} />}
            <div className={`report_page_${pageId}`} dangerouslySetInnerHTML={{ __html: pageHTML }} style={isPDF ? {height: '1080px'} : undefined}>
            </div>
        </>
    )
}

export default ReportRenderer